<template>
  <el-dialog
    v-if="dialogType==='subscribe'"
    :visible.sync="innerVisible"
    :title="$t('Price.Subscribe')"
    width="900px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="subscribe-dialog"
  >
    <div>
      <el-button no="submit" type="primary" @click="submit">{{ $t('Price.Confirm') }}</el-button>
      <el-button
        no="resetForm"
        type="primary"
        @click="resetForm"
      >{{ $t('Price.Reset') }}
      </el-button>
      <el-button no="refreshForm" type="primary" @click="refreshForm">{{ $t('Price.Refresh') }}</el-button>
      <el-button no="cancel" @click="cancel">{{ $t('Price.Cancel') }}</el-button>
    </div>
    <p class="primary-text">{{ $t('Price.PleaseYouWillReceiveUpdated') }}</p>
    <el-form
      ref="form"
      label-position="top"
      :model="form"
    >
      <el-form-item
        style="padding-bottom: 5px;"
        :label="$t('Price.SetEmailToReceiveInformation')"
        prop="mail"
        :rules="[
          { required: true, message: $t('Price.TheEmailCannotBeEmpty')},
          { type: 'email', message: $t('Price.EmailFormatError')}
        ]"
      >
        <el-input v-model="form.mail" no="mail" />
      </el-form-item>
      <el-form-item
        :label="$t('Price.SetCompanyToReceiveInformation')"
        prop="officeList"
      >
        <el-checkbox-group v-model="form.officeList">
          <el-col
            v-for="office in officeList"
            :key="office.officeId"
            :span="4"
          >
            <el-checkbox :label="office.officeId" :title="isZh?office.chineseName:office.englishName">{{ office.code }}</el-checkbox>
          </el-col>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item
        v-show="partnerList && partnerList.length > 0"
        :label="$t('Price.SetYouWantToTo')"
        prop="partnerList"
      >
        <el-checkbox-group v-model="form.partnerList">
          <el-col
            v-for="partner in partnerList"
            :key="partner.tenantId"
            :span="8"
          >
            <el-checkbox :label="partner.tenantId">{{ partner.name }}</el-checkbox>
          </el-col>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      style="text-align: right"
    >
      <el-button no="advanceConfig" type="primary" @click="onAdvanceConfig">{{ $t('Price.AdvancedSettings') }}</el-button>
    </div>
  </el-dialog>
  <el-dialog
    v-else
    :visible.sync="innerVisible"
    :title="$t('Price.AdvancedSettings')"
    :width="$selectByLang('650px', '680px')"
    :close-on-click-modal="false"
    :append-to-body="true"
    :destroy-on-close="true"
    top="5vh"
    custom-class="subscribe-dialog"
  >
    <div style="display: flex">
      <template v-if="priceSubscribeType === 'grid'">
        <div>
          <el-button no="priceSubscribe" type="primary" @click="onAddPriceSubscribe">{{ $t('Price.Add') }}</el-button>
          <el-button
            no="mailSubscribe"
            type="primary"
            :disabled="priceSubscribeForm.mailSubscribe === null"
            @click="onEditPriceSubscribe"
          >{{ $t('Price.Edit') }}
          </el-button>
          <el-button no="dangerDelete" type="danger" :disabled="priceSubscribeForm.mailSubscribe === null" @click="onDeletePriceSubscribe">{{ $t('Price.Delete') }}</el-button>
          <el-button no="subscribe" @click="onBackToSubscribe">{{ $t('Price.GoBack') }}</el-button>
        </div>
        <p class="primary-text" style="flex:1;margin:0;text-align: right">{{ txtOutline }}</p>
      </template>
      <div v-else>
        <el-button no="save" type="primary" @click="onSavePriceSubscribe">{{ $t('Price.Save') }}</el-button>
        <el-button no="cancel" @click="onCancel">{{ $t('Price.Cancel') }}</el-button>
      </div>
    </div>
    <div v-if="priceSubscribeType === 'grid'" class="content-wrapper">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        :show-side-bar="false"
        auto-fit-content
        style="height:300px"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <div v-else class="content-wrapper">
      <el-form ref="priceSubscribeForm" :model="priceSubscribeForm" :label-width="$selectByLang('80px', '120px')">
        <el-form-item :label="$t('Price.SubscriptionType')" class="custom" prop="priceSubscribeType">
          <el-radio-group v-model="priceSubscribeForm.priceSubscribeType" no="priceSubscribeType">
            <el-radio no="office" :label="0">{{ $t('Price.SubCompany') }}</el-radio>
            <el-radio v-show="partnerList && partnerList.length > 0" no="partnerList" :label="1">Tenant</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-show="priceSubscribeForm.priceSubscribeType === 0" prop="officeCode">
          <el-select v-model="priceSubscribeForm.officeCode" no="officeCode">
            <el-option no="all" value="ALL">ALL</el-option>
            <el-option v-for="office in officeList" :key="office.officeId" no="officeList" :value="office.code">{{ office.code }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="priceSubscribeForm.priceSubscribeType === 1" prop="cmpIdx">
          <cargo-advance-select
            no="cmpIdx"
            :default-value="!priceSubscribeForm.cmpIdx? '': priceSubscribeForm.cmpIdx"
            :static-options="partnerList"
            :placeholder="$t('Pricing.TenantPrompt')"
            tag-value="code"
            tag-name="tenantId"
            :custom-label="(item)=>`[${item.tenantId}]${isZh?item.name:item.englishName}`"
            :show-custom-label-in-option="true"
            @parentCallBack="item=>priceSubscribeForm.cmpIdx=item.code"
          />
        </el-form-item>
        <el-form-item :label="$t('Price.PlaceOfDeparture')" class="custom" prop="deliveryType">
          <el-radio-group v-model="priceSubscribeForm.deliveryType" no="deliveryType">
            <el-radio no="load" :label="0">{{ $t('Price.DeparturePort') }}</el-radio>
            <el-radio no="loadCountry" :label="1">{{ $t('Price.DepartureCountry') }}</el-radio>
            <el-radio no="region" :label="2">{{ $t('Price.DepartureArea') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-show="priceSubscribeForm.deliveryType === 0">
          <el-form-item prop="delivery0">
            <div style="display: flex">
              <cargo-advance-select
                no="delivery0"
                :select-type="isAr?selectTypeNames.basic_data_Airport:selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="priceSubscribeForm.delivery0"
                :placeholder="$t('Pricing.PortPrompt')"
                :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                :filter-tag-names="['code','englishName']"
                :show-custom-label-in-option="true"
                style="flex: 1"
                @parentCallBack="item=>priceSubscribeForm.delivery0=item.code"
              />
              <span class="form-operator" @click="onPriceSubscribeFormAdd('delivery')"><i class="el-icon-circle-plus" /></span>
              <span class="form-operator" @click="onPriceSubscribeFormRemove('delivery')"><i class="el-icon-remove" /></span>
            </div>
          </el-form-item>
          <el-form-item class="custom" prop="deliveryCodes0">
            <el-checkbox-group v-model="priceSubscribeForm.deliveryCodes0">
              <el-col
                v-for="code in deliveryCheckBoxGroup0"
                :key="code"
                :span="8"
              >
                <el-checkbox :label="code" :title="code">{{ code }}</el-checkbox>
              </el-col>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div v-show="priceSubscribeForm.deliveryType === 1">
          <el-form-item prop="delivery1">
            <div style="display: flex">
              <cargo-advance-select
                no="delivery1"
                :select-type="selectTypeNames.basic_data_Country"
                :placeholder="$t('Pricing.CountryPrompt')"
                filterable
                :default-value="priceSubscribeForm.delivery1"
                style="flex: 1"
                @parentCallBack="item=>priceSubscribeForm.delivery1=item.code"
              />
              <span class="form-operator" @click="onPriceSubscribeFormAdd('delivery')"><i class="el-icon-circle-plus" /></span>
              <span class="form-operator" @click="onPriceSubscribeFormRemove('delivery')"><i class="el-icon-remove" /></span>
            </div>
          </el-form-item>
          <el-form-item class="custom" prop="deliveryCodes1">
            <el-checkbox-group v-model="priceSubscribeForm.deliveryCodes1">
              <el-col
                v-for="code in deliveryCheckBoxGroup1"
                :key="code"
                :span="8"
              >
                <el-checkbox :label="code" :title="code">{{ resolveColumnLabel(selectTypeNames.basic_data_Country, 'code', code, 'name') }}</el-checkbox>
              </el-col>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div v-show="priceSubscribeForm.deliveryType === 2">
          <el-form-item prop="delivery2">
            <div style="display: flex">
              <cargo-advance-select
                no="delivery2"
                :select-type="selectTypeNames.basic_data_Region"
                :default-value="priceSubscribeForm.delivery2"
                style="flex: 1"
                @parentCallBack="item=>priceSubscribeForm.delivery2=item.code"
              />
              <span class="form-operator" @click="onPriceSubscribeFormAdd('delivery')"><i class="el-icon-circle-plus" /></span>
              <span class="form-operator" @click="onPriceSubscribeFormRemove('delivery')"><i class="el-icon-remove" /></span>
            </div>
          </el-form-item>
          <el-form-item class="custom" prop="deliveryCodes2">
            <el-checkbox-group v-model="priceSubscribeForm.deliveryCodes2">
              <el-col
                v-for="code in deliveryCheckBoxGroup2"
                :key="code"
                :span="8"
              >
                <el-checkbox :label="code" :title="code">{{ resolveColumnLabel(selectTypeNames.basic_data_Region, 'code', code, 'name') }}</el-checkbox>
              </el-col>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <el-form-item :label="$t('Price.DischargePort')" class="custom" prop="unloadingType">
          <el-radio-group v-model="priceSubscribeForm.unloadingType" no="unloadingType">
            <el-radio no="load" :label="0">{{ $t('Price.DestinationPort') }}</el-radio>
            <el-radio no="dest" :label="1">{{ $t('Price.DestinationCountryRegion') }}</el-radio>
            <el-radio no="region" :label="2">{{ $t('Price.DestinationArea') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-show="priceSubscribeForm.unloadingType === 0">
          <el-form-item prop="unloading0">
            <div style="display: flex">
              <cargo-advance-select
                no="unloading0"
                :select-type="isAr?selectTypeNames.basic_data_Airport:selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="priceSubscribeForm.unloading0"
                :placeholder="$t('Pricing.PortPrompt')"
                :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                :filter-tag-names="['code','englishName']"
                :show-custom-label-in-option="true"
                style="flex: 1"
                @parentCallBack="item=>priceSubscribeForm.unloading0=item.code"
              />
              <span class="form-operator" @click="onPriceSubscribeFormAdd('unloading')"><i class="el-icon-circle-plus" /></span>
              <span class="form-operator" @click="onPriceSubscribeFormRemove('unloading')"><i class="el-icon-remove" /></span>
            </div>
          </el-form-item>
          <el-form-item class="custom" prop="unloadingCodes0">
            <el-checkbox-group v-model="priceSubscribeForm.unloadingCodes0">
              <el-col
                v-for="code in unloadingCheckBoxGroup0"
                :key="code"
                :span="8"
              >
                <el-checkbox :label="code" :title="code">{{ code }}</el-checkbox>
              </el-col>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div v-show="priceSubscribeForm.unloadingType === 1">
          <el-form-item prop="unloading1">
            <div style="display: flex">
              <cargo-advance-select
                no="unloading1"
                :select-type="selectTypeNames.basic_data_Country"
                :placeholder="$t('Pricing.CountryPrompt')"
                filterable
                :default-value="priceSubscribeForm.unloading1"
                style="flex: 1"
                @parentCallBack="item=>priceSubscribeForm.unloading1=item.code"
              />
              <span class="form-operator" @click="onPriceSubscribeFormAdd('unloading')"><i class="el-icon-circle-plus" /></span>
              <span class="form-operator" @click="onPriceSubscribeFormRemove('unloading')"><i class="el-icon-remove" /></span>
            </div>
          </el-form-item>
          <el-form-item class="custom" prop="unloadingCodes1">
            <el-checkbox-group v-model="priceSubscribeForm.unloadingCodes1">
              <el-col
                v-for="code in unloadingCheckBoxGroup1"
                :key="code"
                :span="8"
              >
                <el-checkbox :label="code" :title="code">{{ resolveColumnLabel(selectTypeNames.basic_data_Country, 'code', code, 'name') }}</el-checkbox>
              </el-col>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div v-show="priceSubscribeForm.unloadingType === 2">
          <el-form-item prop="unloading2">
            <div style="display: flex">
              <cargo-advance-select
                no="unloading2"
                :select-type="selectTypeNames.basic_data_Region"
                :default-value="priceSubscribeForm.unloading2"
                style="flex: 1"
                @parentCallBack="item=>priceSubscribeForm.unloading2=item.code"
              />
              <span class="form-operator" @click="onPriceSubscribeFormAdd('unloading')"><i class="el-icon-circle-plus" /></span>
              <span class="form-operator" @click="onPriceSubscribeFormRemove('unloading')"><i class="el-icon-remove" /></span>
            </div>
          </el-form-item>
          <el-form-item class="custom" prop="unloadingCodes2">
            <el-checkbox-group v-model="priceSubscribeForm.unloadingCodes2">
              <el-col
                v-for="code in unloadingCheckBoxGroup2"
                :key="code"
                :span="8"
              >
                <el-checkbox :label="code" :title="code">{{ resolveColumnLabel(selectTypeNames.basic_data_Region, 'code', code, 'name') }}</el-checkbox>
              </el-col>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <el-form-item :label="isAr?$t('Price.Airline'):$t('Price.ShippingCompany')" prop="carrier">
          <div style="display: flex">
            <cargo-advance-select
              no="carrier"
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="isAr?{airCmp:true}:{seaCmp:true}"
              filterable
              :default-value="priceSubscribeForm.carrier"
              :custom-label="(item)=>`[${item.shortName}]${item.chineseName}`"
              :show-custom-label-in-option="true"
              tag-value="shortName"
              style="flex: 1"
              @parentCallBack="item=>priceSubscribeForm.carrier=item.shortName"
            />
            <span class="form-operator" @click="onPriceSubscribeFormAdd('carrier')"><i class="el-icon-circle-plus" /></span>
            <span class="form-operator" @click="onPriceSubscribeFormRemove('carrier')"><i class="el-icon-remove" /></span>
          </div>
        </el-form-item>
        <el-form-item class="custom" prop="carrierCodes">
          <el-checkbox-group v-model="priceSubscribeForm.carrierCodes">
            <el-col
              v-for="code in carrierCheckBoxGroup"
              :key="code"
              :span="8"
            >
              <el-checkbox :label="code" :title="code">{{ resolveColumnLabel(selectTypeNames.basic_data_Company, 'shortName', code, 'shortName') }}</el-checkbox>
            </el-col>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { cacheName, cache } from '@/utils/cacheManager'
import { queryAllInviteTenants } from '@/api/price/tenantSharing'
import { queryAllMailSubscribes, saveMailSubscribes2, saveOrUpdateMailSubscribes } from '@/api/price/mailSubscribe'
import { sortByMultiFieldAndOrder } from '@/utils'
import { getLoading } from '@/utils/utilBaseElement'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import $store from '@/store'
import { PriceSubscribeShape } from '@/class/cargo/model/utils/PriceSubscribeShape'
import StrUtils from '@/utils/StrUtils'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'

export default {
  name: 'SubscribeDialog',
  components: { CargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    priceName: {
      type: String,
      default: () => 'PF'
    },
    localEmail: {
      type: String,
      default: () => ''
    },
    isAr: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      resolveColumnLabel: ColumnUtils.resolveColumnLabel,
      loading: null,
      haveTenantSharing: false,
      form: {
        mail: '',
        officeList: [],
        partnerList: []
      },
      txtOutline: '',
      officeCheckMap: {},
      tenantCheckMap: {},
      priceSubscribeShape: {},
      tenantMap: {},
      officeMap: {},
      officeList: [],
      partnerList: [],
      priceSharing: '',
      dialogType: 'subscribe',
      gridOptions: {
        rowSelection: 'single',
        suppressContextMenu: true,
        onRowClicked: this.onRowClickedEvent
      },
      gridApi: {},
      columnDefs: [
        {
          headerName: this.$t('Price.SubscriptionType'),
          field: 'shape',
          colId: 'shape',
          cellRenderer: (params) => {
            return this.pointLabelFunc(params.data)
          }
        }, {
          headerName: this.$t('Price.PlaceOfDeparture'),
          field: 'clnPOL',
          colId: 'clnPOL',
          cellRenderer: (params) => {
            return this.polOrPodLabelFunc(params.data, 'POL', 'COL', 'ROL')
          }
        }, {
          headerName: this.$t('Price.DischargePort'),
          field: 'clnPOD',
          colId: 'clnPOD',
          cellRenderer: (params) => {
            return this.polOrPodLabelFunc(params.data, 'POD', 'COD', 'ROD')
          }
        }, {
          headerName: this.$t('Price.ShippingCompany'),
          field: 'carrier',
          colId: 'carrier',
          cellRenderer: (params) => {
            return this.carrierLabelFunc(params)
          }
        }
      ],
      rowData: [],
      mailSubscribeData: [],
      selectedData: null,
      priceSubscribeType: 'grid',
      priceSubscribeForm: {
        priceSubscribeType: 0,
        deliveryType: 0,
        unloadingType: 0,
        carrier: '',
        officeCode: 'ALL',
        cmpIdx: '',
        delivery0: '',
        deliveryCodes0: [],
        delivery1: '',
        deliveryCodes1: [],
        delivery2: 'SA',
        deliveryCodes2: [],
        unloading0: '',
        unloadingCodes0: [],
        unloading1: '',
        unloadingCodes1: [],
        unloading2: 'SA',
        unloadingCodes2: [],
        carrierCodes: [],
        mailSubscribe: null
      },
      deliveryCheckBoxGroup0: [],
      deliveryCheckBoxGroup1: [],
      deliveryCheckBoxGroup2: [],
      unloadingCheckBoxGroup0: [],
      unloadingCheckBoxGroup1: [],
      unloadingCheckBoxGroup2: [],
      carrierCheckBoxGroup: []
    }
  },
  computed: {
    isZh() {
      return this.$i18n.locale === 'zh'
    },
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
          this.$emit('saveLocalEmail', this.form.mail)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  mounted() {
    this.initForm()
  },
  methods: {
    async initForm() {
      switch (this.priceName) {
        case 'PF':
          this.priceSharing = 'PriceFclSharing'
          break
        case 'PA':
          this.priceSharing = 'PriceAirSharing'
          break
      }
      this.loading = getLoading('subscribe-dialog')
      this.form.mail = !this.localEmail ? $store.getters.userInfo.email : this.localEmail
      try {
        await this.initOfficeList()
        await this.initPartnerList()
        await this.initMailSubscribes()
      } catch (err) {
        console.log(err)
      } finally {
        this.loading.close()
      }
    },
    async initOfficeList() {
      await cache.load(cacheName.OFFICE_LIST)
      const officeList = cache.officeList.filter(office => !(office.officeId === 1 && !this.$store.getters.isGroupCompany))
      // 初始化勾选
      this.officeList = sortByMultiFieldAndOrder(officeList, { code: 'asc' })
    },
    async initPartnerList() {
      const res = await queryAllInviteTenants({ category: this.priceSharing })
      this.initTenant(res.data)
    },
    async initMailSubscribes() {
      const res = await queryAllMailSubscribes({ name: this.priceName, subscriberId: $store.getters.userId })
      // this.rowData = res.data
      this.buildMap(res.data)
      this.mailSubscribeData = res.data
      this.setData()
    },
    resetForm() {
      this.form.officeList = []
      this.form.partnerList = []
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const mssNew = this.getNewSelects()
          const mssDel = this.getDelSelects()
          const params = { mssNew: mssNew, mssDel: mssDel }
          saveMailSubscribes2(params).then(res => {
            this.$message.success(this.$t('Message.SaveSuccessfully'))
            this.cancel()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    refreshForm() {
      this.priceSubscribeForm.mailSubscribe = null
      this.initForm()
    },
    cancel() {
      this.$emit('saveLocalEmail', this.form.mail)
      this.$emit('close')
    },
    onAdvanceConfig() {
      this.priceSubscribeForm.mailSubscribe = null
      this.dialogType = 'advance'
    },
    onAddPriceSubscribe() {
      this.priceSubscribeForm.mailSubscribe = this.createMailSubscribe()
      this.priceSubscribeForm.mailSubscribe['PriceSubscribeShape'] = new PriceSubscribeShape('')
      this.priceSubscribeType = 'form'
      this.resetPriceSubscribeForm()
    },
    onEditPriceSubscribe() {
      this.resetPriceSubscribeForm()
      const mailSubscribe = this.priceSubscribeForm.mailSubscribe
      this.priceSubscribeForm.priceSubscribeType = mailSubscribe.category === 'Tenant' ? 1 : 0
      const ps = this.priceSubscribeForm.mailSubscribe['PriceSubscribeShape']
      // Office or Tenant
      if (ps.has('OFFICE')) {
        const pt = ps.getVal('OFFICE')
        this.priceSubscribeForm.officeCode = pt === -1 ? 0 : pt
      } else if (ps.has('TENANT')) {
        this.priceSubscribeForm.cmpIdx = mailSubscribe.point
      }

      // Place of Loading
      if (ps.has('POL')) {
        const result = PriceUtils.split(ps.getVal('POL'), true)
        this.deliveryCheckBoxGroup0 = result.data
        this.priceSubscribeForm.deliveryType = 0
      } else if (ps.has('COL')) {
        const result = PriceUtils.split(ps.getVal('COL'), true)
        this.deliveryCheckBoxGroup1 = result.data
        this.priceSubscribeForm.deliveryType = 1
      } else if (ps.has('ROL')) {
        const result = PriceUtils.split(ps.getVal('ROL'), true)
        this.deliveryCheckBoxGroup2 = result.data
        this.priceSubscribeForm.deliveryType = 2
      }

      // Place of Discharge
      if (ps.has('POD')) {
        const result = PriceUtils.split(ps.getVal('POD'), true)
        this.unloadingCheckBoxGroup0 = result.data
        this.priceSubscribeForm.unloadingType = 0
      } else if (ps.has('COD')) {
        const result = PriceUtils.split(ps.getVal('COD'), true)
        this.unloadingCheckBoxGroup1 = result.data
        this.priceSubscribeForm.unloadingType = 1
      } else if (ps.has('ROD')) {
        const result = PriceUtils.split(ps.getVal('ROD'), true)
        this.unloadingCheckBoxGroup2 = result.data
        this.priceSubscribeForm.unloadingType = 2
      }
      if (ps.has('CARRIER')) {
        const result = PriceUtils.split(ps.getVal('CARRIER'), true)
        this.carrierCheckBoxGroup = result.data
      }
      console.info('this.priceSubscribeForm.mailSubscribe', this.priceSubscribeForm.mailSubscribe)
      this.priceSubscribeType = 'form'
    },
    onDeletePriceSubscribe() {
      if (!this.priceSubscribeForm.mailSubscribe) {
        return
      }
      const mssDel = [this.priceSubscribeForm.mailSubscribe]
      const params = { mssDel: mssDel }
      saveMailSubscribes2(params).then(res => {
        this.$message.success(this.$t('Message.DeleteSuccessfully'))
        this.refreshForm()
      })
    },
    onBackToSubscribe() {
      this.dialogType = 'subscribe'
    },
    onSavePriceSubscribe() {
      const ps = this.priceSubscribeForm.mailSubscribe['PriceSubscribeShape']
      // Office or Tenant
      if (this.priceSubscribeForm.priceSubscribeType === 0) {
        if (this.priceSubscribeForm.officeCode) {
          this.priceSubscribeForm.mailSubscribe['category'] = 'Office'
          this.priceSubscribeForm.mailSubscribe['point'] = String(this.priceSubscribeForm.officeCode)
          ps.setVal('OFFICE', this.priceSubscribeForm.officeCode)
        } else {
          this.$message.warn(this.$t('Pricing.PlsSelectOffice'))
          return
        }
      } else if (this.priceSubscribeForm.priceSubscribeType === 1) {
        if (this.priceSubscribeForm.cmpIdx) {
          this.priceSubscribeForm.mailSubscribe['category'] = 'Tenant'
          this.priceSubscribeForm.mailSubscribe['point'] = String(this.priceSubscribeForm.cmpIdx)
          this.priceSubscribeForm.mailSubscribe['tenant'] = this.priceSubscribeForm.cmpIdx
          ps.setVal('TENANT', this.priceSubscribeForm.cmpIdx)
        } else {
          this.$message.warn(this.$t('Pricing.PlsSelectTenant'))
          return
        }
      }
      // Place of Loading
      if (this.priceSubscribeForm.deliveryType === 0) {
        ps.setVal('POL', this.deliveryCheckBoxGroup0.join(','))
      } else if (this.priceSubscribeForm.deliveryType === 1) {
        ps.setVal('COL', this.deliveryCheckBoxGroup1.join(','))
      } else if (this.priceSubscribeForm.deliveryType === 2) {
        ps.setVal('ROL', this.deliveryCheckBoxGroup2.join(','))
      }

      // Place of Discharge
      if (this.priceSubscribeForm.unloadingType === 0) {
        ps.setVal('POD', this.unloadingCheckBoxGroup0.join(','))
      } else if (this.priceSubscribeForm.unloadingType === 1) {
        ps.setVal('COD', this.unloadingCheckBoxGroup1.join(','))
      } else if (this.priceSubscribeForm.unloadingType === 2) {
        ps.setVal('ROD', this.unloadingCheckBoxGroup2.join(','))
      }
      ps.setVal('CARRIER', this.carrierCheckBoxGroup.join(','))

      const shape = ps.toString()
      this.priceSubscribeForm.mailSubscribe.shape = shape
      saveOrUpdateMailSubscribes(this.priceSubscribeForm.mailSubscribe).then(res => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.priceSubscribeType = 'grid'
        this.refreshForm()
      })
    },
    resetPriceSubscribeForm() {
      this.deliveryCheckBoxGroup0 = []
      this.deliveryCheckBoxGroup1 = []
      this.deliveryCheckBoxGroup2 = []
      this.unloadingCheckBoxGroup0 = []
      this.unloadingCheckBoxGroup1 = []
      this.unloadingCheckBoxGroup2 = []
      this.carrierCheckBoxGroup = []
      this.priceSubscribeForm.cmpIdx = 0
    },
    onCancel() {
      this.priceSubscribeType = 'grid'
    },
    onPriceSubscribeFormAdd(type) {
      const formType = type === 'carrier' ? '' : this.priceSubscribeForm[`${type}Type`]
      const code = this.priceSubscribeForm[`${type}${formType}`]
      if (code) {
        if (this[`${type}CheckBoxGroup${formType}`].indexOf(code) === -1) {
          const newCheckBoxGroup = [...this[`${type}CheckBoxGroup${formType}`], code]
          this[`${type}CheckBoxGroup${formType}`] = newCheckBoxGroup
          this.priceSubscribeForm[`${type}${formType}`] = ''
        }
      } else {
        const code = this[`${type}CheckBoxGroup${formType}`][this[`${type}CheckBoxGroup${formType}`].length - 1]
        this.priceSubscribeForm[`${type}Codes${formType}`] = [...this.priceSubscribeForm[`${type}Codes${formType}`], code]
      }
    },
    onPriceSubscribeFormRemove(type) {
      const formType = type === 'carrier' ? '' : this.priceSubscribeForm[`${type}Type`]
      this[`${type}CheckBoxGroup${formType}`] = this[`${type}CheckBoxGroup${formType}`].filter(code => this.priceSubscribeForm[`${type}Codes${formType}`].indexOf(code) === -1)
      this.priceSubscribeForm[`${type}Codes${formType}`] = this.priceSubscribeForm[`${type}Codes${formType}`].filter(code => this[`${type}CheckBoxGroup${formType}`].indexOf(code) !== -1)
    },
    initTenant(tenants) {
      this.partnerList = []
      if (tenants === null || tenants.length === 0) {
        this.haveTenantSharing = false
        return
      }
      const currentTenantId = $store.getters.tenantId
      tenants.forEach(tenant => {
        tenant['selected'] = false
        if (currentTenantId !== tenant.tenantId) { // 剔除当前用户所在的Tenant
          this.partnerList.push(tenant)
        }
      })
      this.haveTenantSharing = true
    },
    buildMap(data) {
      this.rowData = []
      this.officeCheckMap = {}
      this.tenantCheckMap = {}
      data.forEach(item => {
        if (!this.priceSubscribeShape.hasOwnProperty(item.shape)) {
          this.priceSubscribeShape[item.shape] = new PriceSubscribeShape(item.shape)
        }
        switch (item.category) {
          case 'Office':
            if (item.shape.indexOf(':') < 0) { // 没有POL等限制条件，纯粹是分公司code
              this.officeMap[item.shape] = 0
            } else {
              item['PriceSubscribeShape'] = this.priceSubscribeShape[item.shape]
              this.rowData.push(item)
            }
            this.officeCheckMap[item.point] = true
            break
          case 'Tenant':
            if (item.shape.indexOf(':') < 0) { // 没有POL等限制条件，纯粹是Tenant 的code
              this.tenantMap[item.shape] = 0
            } else {
              item['PriceSubscribeShape'] = this.priceSubscribeShape[item.shape]
              this.rowData.push(item)
            }
            this.tenantCheckMap[item.point] = true
            break
          default:
            break
        }
      })
    },
    setData() {
      if (this.officeCheckMap) {
        const officeChecks = []
        for (const index in this.officeCheckMap) {
          officeChecks.push(Number(index))
        }
        this.form.officeList = officeChecks
      }
      if (this.tenantCheckMap) {
        const tenantChecks = []
        for (const index in this.tenantCheckMap) {
          tenantChecks.push(Number(index))
        }
        this.form.partnerList = tenantChecks
      }
    },
    pointLabelFunc(data) {
      if (data['PriceSubscribeShape']) {
        if (data.PriceSubscribeShape.has('OFFICE')) {
          return data.PriceSubscribeShape.getOffice()
        }
        if (data.PriceSubscribeShape.has('TENANT')) {
          return data.PriceSubscribeShape.getTenant()
        }
      }
      return ''
    },
    polOrPodLabelFunc(data, pField, countryField, regionField) {
      const ps = data['PriceSubscribeShape']
      if (ps.has(pField)) {
        return ps.getVal(pField)
      }
      const rs = []
      if (ps.has(countryField)) {
        const cys = ps.getVal(countryField).split(',')
        cys.forEach(c => {
          const countryName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', c, 'name')
          if (!StrUtils.isEmpty(countryName)) {
            rs.push(countryName)
          }
        })
        return rs.join()
      }
      if (ps.has(regionField)) {
        const targetField = $store.getters.language === 'zh' ? 'name' : 'nameEnglish'
        const rgs = ps.getVal(regionField).split(',')
        rgs.forEach(r => {
          const regionName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Region, 'code', r, targetField)
          if (!StrUtils.isEmpty(regionName)) {
            rs.push(regionName)
          }
        })
        return rs.join()
      }
      return ''
    },
    carrierLabelFunc(params) {
      const ps = params.data['PriceSubscribeShape']
      if (ps.has('CARRIER')) {
        const carrier = ps.getVal('CARRIER')
        return carrier.substr(1, carrier.length - 2)
      }
      return ''
    },
    getNewSelects() {
      const mss = []
      const officeChecks = {}
      for (const index of this.form.officeList) {
        officeChecks[index] = true
      }
      this.officeList.forEach(office => {
        if (!this.officeCheckMap[office.officeId] && officeChecks[office.officeId]) {
          const ms = this.createMailSubscribe()
          ms.shape = office.code
          ms.category = 'Office'
          ms.point = office.officeId
          mss.push(ms)
        }
      })
      const tenantChecks = {}
      for (const index of this.form.partnerList) {
        tenantChecks[index] = true
      }
      this.partnerList.forEach(tenant => {
        if (!this.tenantCheckMap[tenant.tenantId] && tenantChecks[tenant.tenantId]) {
          const ms = this.createMailSubscribe()
          ms.shape = tenant.name
          ms.category = 'Tenant'
          ms.point = tenant.tenantId.toString()
          mss.push(ms)
        }
      })
      return mss
    },
    createMailSubscribe() {
      const ms = {}
      ms.name = this.priceName
      ms.mail = this.form.mail
      ms.subscriberId = $store.getters.userId
      const _user = $store.getters.userInfo
      ms.subscriberName = _user.englishName ? _user.englishName : _user.chineseName
      ms.createdBy = _user.userId
      ms.dateCreated = new Date()
      ms.isActive = true
      return ms
    },
    getDelSelects() {
      const mss = []
      const officeChecks = {}
      for (const index of this.form.officeList) {
        officeChecks[index] = true
      }
      const tenantChecks = {}
      for (const index of this.form.partnerList) {
        tenantChecks[index] = true
      }
      this.mailSubscribeData.forEach(item => {
        if (!StrUtils.isEmpty(item.point)) {
          if (item.category === 'Office') {
            if (this.officeCheckMap[item.point] && !officeChecks[item.point]) {
              mss.push(item)
            }
          }
          if (item.category === 'Tenant') {
            if (this.tenantCheckMap[item.point] && !tenantChecks[item.point]) {
              mss.push(item)
            }
          }
        }
      })
      return mss
    },
    onRowClickedEvent(e) {
      this.priceSubscribeForm.mailSubscribe = e.data
      const ms = e.data
      if (ms) {
        let outline = ms['PriceSubscribeShape']._shape
        outline = outline.replace(':,', ':')
        outline = outline.replace(',;', ';')
        if (outline.substr(outline.length - 1, 1) === ',') {
          outline = outline.substr(0, outline.length - 1)
        }
        this.txtOutline = outline
      }
    }
  }
}
</script>

<style lang="scss">
@import "~@/styles/element-variables.scss";
.subscribe-dialog{
  .el-dialog__body{
    padding: 10px!important;
  }
  .primary-text {
    color: $--color-primary;
  }
  .content-wrapper{
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    .custom{
      .el-form-item__content{
        width: auto;
      }
    }
    .el-form-item__content{
      width: 240px;
      .form-operator{
        margin-left: 5px;
        cursor: pointer;
        font-size: 18px;
        .el-icon-circle-plus{
          color: $--color-success;
        }
        .el-icon-remove
        {
          color: $--color-danger;
        }
      }
    }
  }
}

</style>
